import api from './api';
import { AuditLogFiltros, AuditLogPageResponse } from '../types/auditoria/AuditoriaTypes';

class AuditoriaService {
  private readonly baseUrl = '/api/auditoria';

  async listar(page = 1, limit = 50, filtros?: AuditLogFiltros): Promise<AuditLogPageResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(filtros?.entidade && { entidade: filtros.entidade }),
      ...(filtros?.usuarioGuid && { usuarioGuid: filtros.usuarioGuid }),
      ...(filtros?.dataInicio && { dataInicio: filtros.dataInicio }),
      ...(filtros?.dataFim && { dataFim: filtros.dataFim }),
    });
    const response = await api.get(`${this.baseUrl}?${params}`);
    return response.data;
  }
}

export const auditoriaService = new AuditoriaService();
export default auditoriaService;
